module.exports = __webpack_public_path__ + "images/mdj/common/common_icon_wa-df88fcc2d3720bb1c0d0f12bb5d1786b.png";